(() => {
  "use strict";

  const site = document.querySelector(".fsafe-site");

  if (!site) {
    return;
  }

  const modal = site.querySelector("[data-frushi-modal]");

  const openButtons = site.querySelectorAll(
    "[data-frushi-open]"
  );

  const closeButtons = site.querySelectorAll(
    "[data-frushi-close]"
  );

  const topButtons = site.querySelectorAll(
    "[data-frushi-top]"
  );


  function openModal() {
    if (!modal) {
      return;
    }

    modal.hidden = false;

    document.documentElement.style.overflow = "hidden";

    const email = modal.querySelector(
      'input[type="email"]'
    );

    if (email) {
      window.setTimeout(() => {
        email.focus();
      }, 50);
    }
  }


  function closeModal() {
    if (!modal) {
      return;
    }

    modal.hidden = true;

    document.documentElement.style.overflow = "";
  }


  openButtons.forEach((button) => {
    button.addEventListener(
      "click",
      openModal
    );
  });


  closeButtons.forEach((button) => {
    button.addEventListener(
      "click",
      closeModal
    );
  });


  topButtons.forEach((button) => {
    button.addEventListener(
      "click",
      () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    );
  });


  document.addEventListener(
    "keydown",
    (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    }
  );
})();


/* ==========================================================
   GOLD MASTER 1.2
   FLOATING BACK TO TOP VISIBILITY
========================================================== */

(() => {
  "use strict";

  const button = document.querySelector(
    "[data-frushi-floating-top]"
  );

  if (!button) {
    return;
  }


  let ticking = false;


  function visibilityThreshold() {
    return Math.max(
      500,
      window.innerHeight * 0.65
    );
  }


  function updateFloatingTop() {
    const shouldShow =
      window.scrollY >
      visibilityThreshold();

    button.classList.toggle(
      "is-visible",
      shouldShow
    );
  }


  function requestUpdate() {
    if (ticking) {
      return;
    }

    ticking = true;

    window.requestAnimationFrame(() => {
      updateFloatingTop();

      ticking = false;
    });
  }


  window.addEventListener(
    "scroll",
    requestUpdate,
    {
      passive: true,
    }
  );


  window.addEventListener(
    "resize",
    requestUpdate
  );


  updateFloatingTop();
})();

